var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Entity } from '@decahedron/entity';
import * as chroma from 'chroma-js';
var Tag = /** @class */ (function (_super) {
    __extends(Tag, _super);
    function Tag() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.companyId = null;
        _this.label = null;
        _this.color = null;
        _this.createdBy = null;
        return _this;
    }
    Object.defineProperty(Tag.prototype, "hexBackground", {
        get: function () {
            return this.color;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Tag.prototype, "hexTextColor", {
        get: function () {
            return chroma(this.color).get('hcl.l') > 75 ? '#000000' : '#ffffff';
        },
        enumerable: false,
        configurable: true
    });
    Tag.prototype.toJdsStructure = function () {
        return {
            color: this.color,
            name: this.label,
        };
    };
    return Tag;
}(Entity));
export { Tag };
